import { validationSaga } from "./saga";
import { createSlice } from "@reduxjs/toolkit";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { useMemo } from "react";

export const initialState = {
  emailValidation: {
    loading: false,
    success: false,
    error: null,
    message: ""
  }
};

export const ValidationSlice = createSlice({
  name: "validation",
  initialState,
  reducers: {
    // trigger email
    validateEmail: (state) => {
      state.emailValidation.loading = true;
      state.emailValidation.error = null;
      state.emailValidation.success = false;
      state.emailValidation.message = "";
    },
    validateEmailSuccess: (state, action) => {
      state.emailValidation.loading = false;
      state.emailValidation.success = true;
      state.emailValidation.error = null;
      state.emailValidation.message = action.payload?.message || "";
    },
    validateEmailFailure: (state, action) => {
      state.emailValidation.loading = false;
      state.emailValidation.success = false;
      state.emailValidation.error = action.payload;
      state.emailValidation.message = "";
    },
    resetEmailValidation: (state) => {
      state.emailValidation.loading = false;
      state.emailValidation.success = false;
      state.emailValidation.error = null;
      state.emailValidation.message = "";
    }
  }
});

export const useValidationSlice = () => {
  useInjectReducer(ValidationSlice.name, ValidationSlice.reducer);
  useInjectSaga(ValidationSlice.name, validationSaga);
  const actions = useMemo(() => ValidationSlice.actions, []);
  return { actions };
};

export const { actions: validationActions } = ValidationSlice;
export default ValidationSlice.reducer;
